import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UrlModal } from 'src/app/shared/url.model';

@Injectable({
  providedIn: 'root'
})
export class FeatureService {

  constructor(private httpClient: HttpClient) { }
  
  getFeatures(token:string) {
    return this.httpClient.get(
      UrlModal._URL + "/feature/",
      {
        headers: new HttpHeaders({
          authorization: "Bearer " + token,
        }),
      }
    );
  }

  creatProduct(
    data:any,
  ) {
    return this.httpClient.post(
      UrlModal._URL + '/feature',
      data,
      {
        headers: new HttpHeaders({}),
      }
    )
  }

  getClinic(token:string) {
    return this.httpClient.get(
      UrlModal._URL + "/ad/allclinics",
      {
        headers: new HttpHeaders({
          authorization: "Bearer " + token,
        }),
      }
    );
  }

  addFeature(token:string,
    data:any,
  ) {
    return this.httpClient.post(
      UrlModal._URL + '/feature/hos',
      data,
      {
        headers: new HttpHeaders({
          authorization: "Bearer " + token,
        }),
      }
    )
  }

  deletDocument(id:any){
    return this.httpClient
    .delete(
      UrlModal._URL + '/feature/' + id,
      {
        headers:new HttpHeaders({}),
      }
    )
  }

  updateProduct(id:any,data:any) {
    return this.httpClient.put(UrlModal._URL + "/feature/" + id ,data, {
      headers: new HttpHeaders({
      })
    });
  }

  // updateProduct(
  //   id:any,data:any,
  // ) {
  //   return this.httpClient.put(
  //     UrlModal._URL + '/feature/'+ id,
  //     data,
  //     {
  //       headers: new HttpHeaders({}),
  //     }
  //   )
  // }


}
